// components/ProtectedRoute.jsx
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = () => {
  const token = localStorage.getItem("access");

  if (!token) {
    toast.error("Session expired. Please login again.");
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;